// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "InfoSection-module--wrapper--rDfXA";
export var introWrapper = "InfoSection-module--introWrapper--q1zs4";
export var introTitle = "InfoSection-module--introTitle--mIGgn";
export var circleWrapper = "InfoSection-module--circleWrapper--0xx7L";